export default __webpack_public_path__ + "static/media/ForLoopImg.16f840d1.jpg";